{
  "common": {
    "memberCenter": "Mitgliederzentrum",
    "points": "Punkte",
    "level": "Stufe",
    "coupons": "Gutscheine",
    "checkin": "Tägliches Einchecken",
    "history": "Verlauf",
    "balance": "Guthaben",
    "expire": "Ablaufen",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "loading": "Laden...",
    "noData": "Keine Daten",
    "retry": "Erneut versuchen",
    "success": "Erfolg",
    "failed": "Fehlgeschlagen"
  },
  "points": {
    "earn": "{amount} Punkte verdient",
    "spend": "{amount} Punkte ausgegeben",
    "balance": "Aktuelles Guthaben: {amount} Punkte",
    "expired": "{amount} Punkte abgelaufen",
    "estimated": "Geschätzt (Bestätigung ausstehend)"
  },
  "level": {
    "current": "Aktuelle Stufe: {name}",
    "nextLevel": "Nächste Stufe: {name}",
    "progress": "{current}/{target} bis zur nächsten Stufe",
    "upgraded": "Glückwunsch! Aufstieg zu {name}"
  },
  "coupon": {
    "claim": "Einlösen",
    "claimed": "Eingelöst",
    "expired": "Abgelaufen",
    "used": "Verwendet",
    "validUntil": "Gültig bis {date}",
    "threshold": {
      "none": "Kein Mindestbetrag",
      "min": "Mindestbestellwert {amount}"
    }
  },
  "checkin": {
    "today": "Heute einchecken",
    "done": "Eingecheckt",
    "streak": "{days} Tage in Folge",
    "reward": "+{amount} Punkte"
  },
  "errors": {
    "network": "Netzwerkfehler, bitte erneut versuchen",
    "unauthorized": "Bitte melden Sie sich an",
    "serverError": "Serverfehler, bitte später erneut versuchen",
    "timeout": "Zeitüberschreitung"
  },
  "ui": {
    "memberCenter": {
      "loading": "Laden...",
      "avatarAlt": "Mitgliederavatar",
      "pointsBalance": "Meine Punkte",
      "menuLabel": "Mitgliedernavigation",
      "menu": {
        "pointsDetail": "Punkteverlauf",
        "levelDetail": "Stufenvorteile",
        "coupons": "Meine Gutscheine",
        "referral": "Freunde einladen",
        "checkin": "Tägliches Einchecken"
      }
    },
    "pointsDetail": {
      "title": "Punkteverlauf",
      "empty": "Keine Punkteeinträge",
      "loading": "Laden...",
      "noMore": "Keine weiteren Einträge",
      "listLabel": "Punktetransaktionen",
      "status": {
        "pending": "Ausstehend",
        "active": "Aktiv",
        "used": "Verwendet",
        "expired": "Abgelaufen"
      }
    },
    "levelProgress": {
      "loading": "Laden...",
      "maxLevel": "Höchste Stufe erreicht",
      "progressLabel": "Stufenfortschritt",
      "noBenefits": "Keine Vorteile",
      "nextLevel": "Nächste Stufe: {name}",
      "benefitsTitle": "Meine Vorteile"
    },
    "couponList": {
      "title": "Meine Gutscheine",
      "tabsLabel": "Gutscheinkategorien",
      "listLabel": "Gutscheinliste",
      "empty": "Keine Gutscheine verfügbar",
      "freeShipping": "Kostenloser Versand",
      "giftValue": "Geschenk",
      "discountValue": "{value}% Rabatt",
      "type": {
        "discount": "Rabatt",
        "cash": "Bargeld",
        "shipping": "Versand",
        "gift": "Geschenk"
      },
      "tab": {
        "available": "Verfügbar",
        "used": "Verwendet",
        "expired": "Abgelaufen",
        "claimable": "Erhältlich"
      },
      "loadingClaimable": "Laden...",
      "noClaimable": "Keine verfügbaren Gutscheine",
      "claiming": "Wird eingelöst...",
      "claim": "Einlösen",
      "stockInfo": "{remaining} übrig",
      "stockUnlimited": "Unbegrenzt",
      "minOrder": "Mind. {amount}"
    },
    "referralShare": {
      "loading": "Laden...",
      "title": "Freunde einladen",
      "shareTitle": "Freunde einladen und Punkte verdienen",
      "shareText": "Jetzt registrieren und ein Geschenk erhalten!",
      "invitedCount": "Eingeladen",
      "rewardPoints": "Verdiente Punkte",
      "codeLabel": "Mein Empfehlungscode",
      "linkLabel": "Empfehlungslink",
      "copy": "Kopieren",
      "copyCode": "Empfehlungscode kopieren",
      "share": "Teilen",
      "rewardHint": "{points} Punkte pro eingeladenem Freund",
      "tabShare": "Einladen",
      "tabRecords": "Verlauf",
      "loadingRecords": "Laden...",
      "noRecords": "Keine Einladungen",
      "anonymousUser": "Anonym",
      "prevPage": "Zurück",
      "nextPage": "Weiter",
      "recordsLabel": "Einladungsliste",
      "status": {
        "registered": "Registriert",
        "first_order": "Erste Bestellung",
        "rewarded": "Belohnt"
      }
    },
    "checkinCalendar": {
      "loading": "Laden...",
      "checking": "Einchecken...",
      "checkin": "Einchecken",
      "alreadyChecked": "Heute eingecheckt",
      "day": "{count} Tage",
      "title": "Tägliches Einchecken",
      "streak": "{days} Tage in Folge",
      "calendarLabel": "Einchecken-Kalender",
      "rewardsTitle": "Serien-Belohnungen",
      "rewardsLabel": "Belohnungsliste",
      "weekday": {
        "sun": "So",
        "mon": "Mo",
        "tue": "Di",
        "wed": "Mi",
        "thu": "Do",
        "fri": "Fr",
        "sat": "Sa"
      },
      "prevMonth": "Vorheriger Monat",
      "nextMonth": "Nächster Monat",
      "monthDays": "{count} Tage diesen Monat",
      "monthPoints": "Monatspunkte"
    },
    "orderList": {
      "loading": "Bestellungen laden...",
      "title": "Bestellverlauf",
      "noOrders": "Keine Bestellungen",
      "listLabel": "Bestellliste",
      "prevPage": "Zurück",
      "nextPage": "Weiter",
      "typePoints": "Punkte",
      "typeGrowth": "Wachstum",
      "bizType": {
        "Order_Pay": "Bestellzahlung",
        "Order_Refund": "Rückerstattung"
      },
      "status": {
        "pending": "Ausstehend",
        "active": "Aktiv",
        "invalid": "Ungültig",
        "used": "Verwendet",
        "expired": "Abgelaufen"
      }
    },
    "addressManager": {
      "title": "Meine Adressen",
      "add": "Hinzufügen",
      "empty": "Keine Adressen",
      "default": "Standard",
      "setDefault": "Als Standard",
      "edit": "Bearbeiten",
      "delete": "Löschen"
    },
    "accountSettings": {
      "title": "Kontoeinstellungen",
      "dataExport": {
        "title": "Daten exportieren",
        "desc": "Kopie aller persönlichen Daten herunterladen",
        "button": "Export anfordern",
        "processing": "Verarbeitung..."
      },
      "deleteAccount": {
        "title": "Konto löschen",
        "desc": "Konto und alle Daten dauerhaft löschen",
        "button": "Konto löschen",
        "confirm": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Daten werden gelöscht.",
        "confirmButton": "Ja, löschen",
        "cancel": "Abbrechen"
      }
    },
    "checkout": {
      "points": {
        "title": "Punkteabzug",
        "unit": "Pkt",
        "available": "Verfügbar",
        "deduct": "Abziehen"
      },
      "coupon": {
        "title": "Gutschein",
        "none": "Kein Gutschein"
      },
      "summary": {
        "order": "Bestellsumme",
        "discount": "Rabatt",
        "total": "Zu zahlen"
      }
    },
    "profile": {
      "form": {
        "nickname": "Spitzname",
        "avatar": "Avatar-URL",
        "locale": "Sprache",
        "save": "Speichern",
        "saving": "Speichern..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "E-Mail",
        "passwordLabel": "Passwort",
        "submit": "Anmelden",
        "createAccount": "Konto erstellen",
        "forgotPassword": "Passwort vergessen?",
        "orDivider": "oder"
      },
      "register": {
        "emailLabel": "E-Mail",
        "passwordLabel": "Passwort",
        "confirmPasswordLabel": "Passwort bestätigen",
        "passwordHint": "Mindestens 8 Zeichen, mit Buchstaben und Zahlen",
        "submit": "Konto erstellen",
        "hasAccount": "Bereits ein Konto? Anmelden",
        "passwordMismatch": "Die Passwörter stimmen nicht überein",
        "submitting": "Wird erstellt..."
      },
      "oauth": {
        "continueWith": "Weiter mit {provider}"
      },
      "verify": {
        "title": "E-Mail bestätigen",
        "description": "Wir haben einen Bestätigungscode an {email} gesendet",
        "digitLabel": "Ziffer {index}",
        "resend": "Code erneut senden",
        "resendCountdown": "Erneut senden ({countdown}s)",
        "backToRegister": "Zurück zur Registrierung"
      },
      "forgot": {
        "title": "Passwort zurücksetzen",
        "description": "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Bestätigungscode.",
        "emailLabel": "E-Mail",
        "submit": "Code senden",
        "backToLogin": "Zurück zur Anmeldung"
      }
    }
  },
  "sdk": {
    "error": {
      "210900": "Ungültige Parameter",
      "210901": "Mandanten-ID ist erforderlich",
      "210902": "Zu viele Anfragen, bitte versuchen Sie es später erneut",
      "210903": "Nicht autorisiert",
      "210904": "Token abgelaufen",
      "210905": "Ungültiges Token",
      "210906": "Token-Aktualisierung fehlgeschlagen",
      "210907": "Plattform-Token-Austausch fehlgeschlagen",
      "210908": "Ungültiges Aktualisierungstoken",
      "210909": "Aktualisierungstoken abgelaufen",
      "210911": "Mitglied nicht gefunden",
      "210912": "Stufeninformationen nicht gefunden",
      "210920": "Diese E-Mail ist bereits registriert",
      "210921": "Passwort zu schwach: mindestens 8 Zeichen mit Buchstaben und Zahlen",
      "210922": "Bestätigungscode zu häufig gesendet, bitte versuchen Sie es später erneut",
      "210923": "Ungültiger oder abgelaufener Bestätigungscode",
      "210924": "Registrierungsinformationen abgelaufen, bitte erneut registrieren",
      "210925": "Falsche E-Mail oder falsches Passwort",
      "210926": "E-Mail nicht verifiziert, bitte zuerst verifizieren",
      "210927": "OAuth-Authentifizierung fehlgeschlagen",
      "210928": "OAuth-Status ungültig oder abgelaufen",
      "210929": "Nicht unterstützte Anmeldemethode",
      "210930": "Benutzererstellung fehlgeschlagen",
      "210931": "Rabattberechnung fehlgeschlagen",
      "210951": "Punktestand-Abfrage fehlgeschlagen",
      "210952": "Punktetransaktions-Abfrage fehlgeschlagen",
      "210953": "Punkte-Sammlung fehlgeschlagen",
      "210954": "Punkte-Aktivierung fehlgeschlagen",
      "210955": "Punkte-Ausgabe fehlgeschlagen",
      "210956": "Unzureichender Punktestand",
      "210957": "Punkte-Hauptbuch nicht gefunden",
      "210958": "Der Punktestatus erlaubt diese Operation nicht",
      "210971": "Coupon nicht vorrätig",
      "210972": "Coupon bereits eingelöst",
      "210981": "Nachrichtenwarteschlange-Schreibfehler",
      "210982": "Interne Servicesynchronisierung fehlgeschlagen",
      "210983": "Austauschprodukt nicht gefunden",
      "210984": "Einlösung fehlgeschlagen",
      "210985": "Empfehlungscode nicht gefunden",
      "210986": "Empfehlungsbindung fehlgeschlagen",
      "210987": "Empfehlungsgeber nicht gefunden",
      "210988": "Sie können sich nicht selbst einladen",
      "210989": "Coupon-Einlösung fehlgeschlagen",
      "210990": "Heute bereits eingecheckt",
      "210991": "Check-in fehlgeschlagen",
      "211001": "Webhook-Signaturüberprüfung fehlgeschlagen",
      "211002": "Nicht unterstützte Webhook-Plattform",
      "211003": "Doppelte Webhook-Anfrage",
      "211004": "Webhook-Secret nicht konfiguriert",
      "211005": "Webhook-Zeitstempel abgelaufen",
      "211900": "Operation fehlgeschlagen, bitte versuchen Sie es erneut",
      "211901": "Authentifizierung fehlgeschlagen",
      "211902": "Konto nicht verknüpft",
      "211903": "Zugriff verweigert",
      "211904": "Konfiguration nicht gefunden",
      "211905": "Ungültiger Konfigurationsbereich",
      "211906": "Rolle nicht gefunden",
      "211907": "Systemrolle kann nicht gelöscht werden",
      "211908": "Kein Zugriff auf diesen Mandanten",
      "211909": "Validierung fehlgeschlagen",
      "211910": "Ressource nicht gefunden",
      "211911": "Mitglied nicht gefunden",
      "211912": "Identitätskonflikt, bitte kontaktieren Sie den Support",
      "211913": "Schattenkontoaktivierung fehlgeschlagen",
      "211914": "Überprüfungsdatensatz nicht gefunden",
      "211915": "Überprüfungsdatensatz-Status ist nicht ausstehend",
      "211916": "OneID nicht gefunden",
      "211917": "OneID-Verknüpfung aufheben fehlgeschlagen",
      "211931": "Stufenkonfiguration nicht gefunden",
      "211932": "Stufe hat zugeordnete Mitglieder, Löschen nicht möglich",
      "211933": "Validierung der Stufen-Upgrade-Bedingung fehlgeschlagen",
      "211934": "Stufenreihenfolge muss fortlaufend sein",
      "211951": "Ungültiger Hauptbuch-Statusübergang",
      "211952": "Unzureichender Punktestand",
      "211953": "Hauptbucheintrag nicht gefunden",
      "211954": "Doppelte Punktetransaktion",
      "211955": "Ungültiger Punktebetrag",
      "211956": "Punkteabzug überschreitet maximales Verhältnis",
      "211957": "Punkte unter Mindestschwelle",
      "211958": "Punkte-Sammelregel nicht konfiguriert",
      "211959": "Punkte-Aktivierung fehlgeschlagen: Status ist nicht ausstehend",
      "211960": "Zugriff auf Punktetransaktion verweigert",
      "211961": "Punkte bereits abgelaufen",
      "211962": "Wachstumsregel nicht konfiguriert",
      "211971": "Coupon-Vorlage nicht gefunden",
      "211972": "Ungültiger Coupon-Vorlagenstatus",
      "211973": "Coupon-Limit pro Benutzer überschritten",
      "211974": "Coupon-Gesamtkontingent überschritten",
      "211975": "Ungültiger Coupon-Einlösungsstatus",
      "211976": "Coupon abgelaufen",
      "211977": "Coupon-Vorlage hat ausgegebene Coupons, Löschen nicht möglich",
      "211981": "Push-Aufgabe nicht gefunden",
      "211982": "Push-Aufgabenstatus erlaubt keine Bearbeitung",
      "211983": "Push-Aufgabenstatus erlaubt keine Stornierung",
      "211984": "Push-Vorlage nicht gefunden",
      "211985": "Push-Zielgruppe ist leer",
      "211991": "Service beschäftigt, bitte versuchen Sie es später erneut",
      "211992": "Nachrichtenveröffentlichung fehlgeschlagen",
      "211993": "Nachricht in Warteschlange für unzustellbare Nachrichten eingereiht",
      "network": "Netzwerkfehler, bitte überprüfen Sie Ihre Verbindung",
      "timeout": "Zeitüberschreitung, bitte versuchen Sie es erneut",
      "aborted": "Anfrage wurde abgebrochen",
      "parse": "Fehler beim Parsen der Antwort",
      "unauthorized": "Bitte melden Sie sich zuerst an",
      "config": "SDK-Initialisierungsfehler",
      "unknown": "Ein unbekannter Fehler ist aufgetreten"
    }
  },
  "exchange": {
    "store": {
      "title": "Punkteshop",
      "myOrders": "Meine Einlösungen",
      "empty": "Keine Produkte verfügbar",
      "points": "Punkte",
      "stock": "Bestand",
      "back": "Zurück",
      "redeem": "Einlösen",
      "soldOut": "Ausverkauft",
      "noOrders": "Keine Einlösungen",
      "status": {
        "pending": "Ausstehend",
        "completed": "Abgeschlossen",
        "cancelled": "Storniert"
      }
    }
  },
  "message": {
    "center": {
      "title": "Nachrichten",
      "empty": "Keine Nachrichten"
    },
    "type": {
      "system": "System",
      "marketing": "Aktionen",
      "transaction": "Transaktion",
      "activity": "Aktivität"
    }
  }
}
